export const LAMBDA_TIMEOUT_504_ERROR =
  'Too many results to display, modify search criteria to reduce the number of results.';
